// ABOUTME: In-memory token storage for Bearer + JWT auth
// ABOUTME: Stores both JWT and session token in memory for Safari compatibility

let jwt: string | null = null
let sessionToken: string | null = null

export function getJwt(): string | null {
  return jwt
}

export function setJwt(token: string): void {
  jwt = token
}

export function getSessionToken(): string | null {
  return sessionToken
}

export function setSessionToken(token: string): void {
  sessionToken = token
}

export function clearTokens(): void {
  jwt = null
  sessionToken = null
}

export function jwtHeaders(): Record<string, string> {
  return jwt ? { Authorization: `Bearer ${jwt}` } : {}
}
